import { Util } from "../../../../utils/util";
import { StoreSelectorUtil } from "../store-selector-util";
import { IStoreLocation } from "../../../../models/data.interface";

export class StoreCardList {
    private _stores: IStoreLocation[] = [];
    private readonly _listContainer: HTMLElement;
    private _selectedStoreKey: string = "";

    // Events triggered on parent component
    public _onStoreSelected: ((storeKey: string) => void) | null = null;
    public _onStoreCardClicked: ((storeKey: string) => void) | null = null;

    constructor(listContainer: HTMLElement) {
        this._listContainer = listContainer;
    }

    public setStores(stores: IStoreLocation[]): void {
        this._stores = stores;
        this._renderStoreList();
    }

    private _renderStoreList(): void {
        if (!this._listContainer) return;

        this._listContainer.innerHTML = "";

        this._stores.forEach((store) => {
            const storeCard = StoreSelectorUtil.createStoreCardElement(
                store,
                (storeKey) => this._onStoreCardClick(storeKey),
                (storeKey) => this._onChooseStoreClick(storeKey),
            );
            this._listContainer?.appendChild(storeCard);
        });
    }

    // In
    public highlightStore(storeKey: string): void {
        const previousSelectedStoreElement = this._listContainer.querySelector(
            `#div_store_selector_store_${this._selectedStoreKey}`,
        );
        previousSelectedStoreElement?.classList.remove("active");

        this._selectedStoreKey = storeKey;
        const currentSelectedStoreElement = this._listContainer.querySelector(
            `#div_store_selector_store_${storeKey}`,
        );

        currentSelectedStoreElement?.classList.add("active");
    }

    public updateStoresVisibility(visibleStoreKeys: string[]): void {
        this._stores.forEach((store) => {
            const storeElement: HTMLElement | null = this._listContainer.querySelector(
                `#div_store_selector_store_${store.storeKey}`,
            );
            if (storeElement) {
                if (visibleStoreKeys.includes(store.storeKey)) {
                    Util.showElement(storeElement);
                } else {
                    Util.hideElement(storeElement);
                }
            }
        });
    }

    // Out
    private _onStoreCardClick(storeKey: string): void {
        this.highlightStore(storeKey);
        this._onStoreCardClicked?.(storeKey);
    }

    private _onChooseStoreClick(storeKey: string) {
        this._onStoreCardClick(storeKey);
        this._onStoreSelected?.(storeKey);
    }
}
